import React, { useState, useEffect } from "react";
import { Button, Container, Row, Col } from "reactstrap";

function BillboardSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div id="billboard-section" style={{
      background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #7e8ba3 100%)',
      padding: '120px 0',
      position: 'relative',
      overflow: 'hidden',
      minHeight: '90vh',
      display: 'flex',
      alignItems: 'center'
    }}>
      {/* Animated Background Elements */}
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            width: Math.random() * 4 + 2 + 'px',
            height: Math.random() * 4 + 2 + 'px',
            background: `rgba(255, 255, 255, ${Math.random() * 0.5 + 0.3})`,
            borderRadius: '50%',
            left: Math.random() * 100 + '%',
            top: Math.random() * 100 + '%',
            animation: `float ${Math.random() * 15 + 10}s infinite linear`,
            animationDelay: Math.random() * 5 + 's'
          }}
        />
      ))}

      {/* Floating Billboard Icons */}
      <div style={{
        position: 'absolute',
        top: '15%',
        left: '8%',
        animation: 'bounce 4s infinite'
      }}>
        <i className="nc-icon nc-map-big" style={{ 
          fontSize: '35px', 
          color: 'rgba(255,255,255,0.2)',
          animation: 'pulse 3s infinite'
        }} />
      </div>

      <div style={{
        position: 'absolute',
        bottom: '20%',
        right: '10%',
        animation: 'bounce 4s infinite 1.5s'
      }}>
        <i className="nc-icon nc-pin-3" style={{ 
          fontSize: '40px', 
          color: 'rgba(255,255,255,0.2)',
          animation: 'pulse 3s infinite 1s'
        }} />
      </div>

      <Container style={{ position: 'relative', zIndex: 2 }}>
        <div style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'all 1s ease-out'
        }}>
          {/* Header Section */}
          <div className="text-center" style={{ marginBottom: '60px' }}>
            <div style={{ marginBottom: '30px' }}>
              <span style={{
                fontSize: '4rem',
                animation: 'bounce 2s infinite'
              }}>
                🚀
              </span>
            </div>
            
            <h2 style={{
              color: 'white',
              fontSize: '3.5rem',
              fontWeight: '700',
              marginBottom: '30px',
              textShadow: '0 4px 10px rgba(0,0,0,0.4)',
              lineHeight: '1.2'
            }}>
              Prime Billboard Locations<br />Across Lebanon
            </h2>

            <div style={{
              width: '120px',
              height: '5px',
              background: 'linear-gradient(90deg, #ff6b6b, #feca57, #4facfe)',
              margin: '0 auto 40px',
              borderRadius: '3px',
              boxShadow: '0 2px 10px rgba(255,107,107,0.4)'
            }}></div>

            <h3 style={{
              color: '#feca57',
              fontSize: '2rem',
              fontWeight: '600',
              marginBottom: '30px',
              textShadow: '0 2px 6px rgba(0,0,0,0.3)'
            }}>
              Maximize Your Brand's Reach!
            </h3>
          </div>

          {/* Main Content */}
          <Row>
            <Col lg="8" style={{ margin: '0 auto' }}>
              <div style={{
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(15px)',
                borderRadius: '25px',
                padding: '50px 40px',
                border: '2px solid rgba(255,255,255,0.2)',
                boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
              }}>
                <p style={{ 
                  color: 'rgba(255,255,255,0.95)', 
                  fontSize: '1.4rem', 
                  fontWeight: '400',
                  lineHeight: '1.9',
                  marginBottom: '35px',
                  textAlign: 'justify',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  Unlock <span style={{ color: '#4facfe', fontWeight: '600' }}>high-impact outdoor advertising</span> with our premium billboards available in <span style={{ color: '#feca57', fontWeight: '600' }}>16 key locations across Lebanon</span>. With dimensions ranging from <span style={{ color: '#ff6b6b', fontWeight: '600' }}>10x4m to 14x4m</span>, our billboards ensure maximum visibility on high-traffic roads, urban centers, and commercial hubs.
                </p>

                <p style={{ 
                  color: 'rgba(255,255,255,0.95)', 
                  fontSize: '1.4rem', 
                  fontWeight: '400',
                  lineHeight: '1.9',
                  marginBottom: '35px',
                  textAlign: 'justify',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  Whether you're <span style={{ color: '#a8edea', fontWeight: '600' }}>launching a new product</span> or <span style={{ color: '#fed6e3', fontWeight: '600' }}>reinforcing brand awareness</span>, our strategically placed billboards guarantee the exposure you need.
                </p>

                <div style={{
                  background: 'linear-gradient(135deg, rgba(255,107,107,0.2), rgba(254,202,87,0.2))',
                  borderRadius: '15px',
                  padding: '30px',
                  marginBottom: '40px',
                  border: '1px solid rgba(255,255,255,0.3)'
                }}>
                  <p style={{ 
                    color: 'white', 
                    fontSize: '1.5rem', 
                    fontWeight: '600',
                    marginBottom: '10px',
                    textAlign: 'center',
                    textShadow: '0 2px 4px rgba(0,0,0,0.4)'
                  }}>
                    ⚡ Secure your spot today – <span style={{ color: '#ff6b6b' }}>Limited availability!</span>
                  </p>
                </div>

                {/* Call to Action Buttons */}
                <div style={{ 
                  display: 'flex', 
                  gap: '20px', 
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                  marginTop: '40px'
                }}>
                  <Button
                    className="btn-round"
                    style={{
                      background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                      border: 'none',
                      padding: '18px 45px',
                      borderRadius: '35px',
                      color: 'white',
                      fontWeight: '700',
                      fontSize: '1.2rem',
                      boxShadow: '0 10px 30px rgba(255, 107, 107, 0.5)',
                      transition: 'all 0.3s ease',
                      transform: 'scale(1)',
                    }}
                    href="#contact"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.boxShadow = '0 15px 40px rgba(255, 107, 107, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 107, 107, 0.5)';
                    }}
                  >
                    <i className="nc-icon nc-tap-01" style={{ marginRight: '12px' }} />
                    Book Your Billboard Now
                  </Button>

                  <Button
                    className="btn-round"
                    style={{
                      background: 'rgba(255,255,255,0.2)',
                      backdropFilter: 'blur(10px)',
                      border: '2px solid white',
                      padding: '18px 45px',
                      borderRadius: '35px',
                      color: 'white',
                      fontWeight: '700',
                      fontSize: '1.2rem',
                      boxShadow: '0 10px 30px rgba(255, 255, 255, 0.2)',
                      transition: 'all 0.3s ease',
                      transform: 'scale(1)',
                    }}
                    href="https://chat.whatsapp.com/FYhyTQAInGk7ygMn2wiGTs"
                    target="_blank"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                      e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                      e.currentTarget.style.boxShadow = '0 15px 40px rgba(255, 255, 255, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(255, 255, 255, 0.2)';
                    }}
                  >
                    <i className="fa fa-whatsapp" style={{ marginRight: '12px' }} />
                    Contact Us on WhatsApp
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

          {/* Feature Highlights */}
          <Row style={{ marginTop: '70px' }}>
            <Col md="4" style={{ marginBottom: '30px' }}>
              <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                background: 'rgba(255,255,255,0.08)',
                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.15)',
                transition: 'all 0.3s ease',
                height: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
                e.currentTarget.style.transform = 'translateY(-10px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '20px'
                }}>
                  📍
                </div>
                <h4 style={{
                  color: 'white',
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  16 Prime Locations
                </h4>
                <p style={{
                  color: 'rgba(255,255,255,0.8)',
                  fontSize: '1.1rem',
                  lineHeight: '1.6'
                }}>
                  Strategic positions across Lebanon's busiest routes and commercial areas
                </p>
              </div>
            </Col>

            <Col md="4" style={{ marginBottom: '30px' }}>
              <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                background: 'rgba(255,255,255,0.08)',
                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.15)',
                transition: 'all 0.3s ease',
                height: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
                e.currentTarget.style.transform = 'translateY(-10px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '20px'
                }}>
                  📏
                </div>
                <h4 style={{
                  color: 'white',
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  Large Formats
                </h4>
                <p style={{
                  color: 'rgba(255,255,255,0.8)',
                  fontSize: '1.1rem',
                  lineHeight: '1.6'
                }}>
                  Billboards from 10x4m to 14x4m for maximum visual impact
                </p>
              </div>
            </Col>

            <Col md="4" style={{ marginBottom: '30px' }}>
              <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                background: 'rgba(255,255,255,0.08)',
                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.15)',
                transition: 'all 0.3s ease',
                height: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.12)';
                e.currentTarget.style.transform = 'translateY(-10px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                <div style={{
                  fontSize: '3rem',
                  marginBottom: '20px'
                }}>
                  👁️
                </div>
                <h4 style={{
                  color: 'white',
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  High Traffic Areas
                </h4>
                <p style={{
                  color: 'rgba(255,255,255,0.8)',
                  fontSize: '1.1rem',
                  lineHeight: '1.6'
                }}>
                  Thousands of daily impressions on busy roads and urban centers
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      {/* Add keyframes for animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          25% { transform: translateY(-20px) translateX(10px); }
          50% { transform: translateY(-10px) translateX(-10px); }
          75% { transform: translateY(-30px) translateX(5px); }
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}

export default BillboardSection;
